import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { VIEW_RELATION_TYPES } from '../../util/constants';

const getAssignmentViewRelation = (state) =>
  _get(state, 'courses.course.data.assignment_views_relation', []);

export const checkReadingTabData = createSelector(
  getAssignmentViewRelation,
  (assignmentViewRelation) =>
    assignmentViewRelation.filter(
      (relation) =>
        relation.assignment_views_id === VIEW_RELATION_TYPES.READING_VIEW_ID
    ).length > 0
);
